import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { Auth0Guard } from "@mrdm-self-service-frontend/shared/util-authorization";
import {
    AdministrationAuthorizationGuard,
    AdministrationPermissions
} from "./shared/authorization";
import { AccessDeniedComponent } from "./shared/component/access-denied/access-denied.component";

const routes: Routes = [
    {
        path: "callback",
        redirectTo: "administration"
    },
    {
        path: "access-denied",
        pathMatch: "full",
        component: AccessDeniedComponent
    },
    {
        path: "",
        loadChildren: () => import("./authorized/authorized.module").then(m => m.AuthorizedModule),
        canLoad: [Auth0Guard, AdministrationAuthorizationGuard],
        canActivate: [Auth0Guard, AdministrationAuthorizationGuard],
        data: {
            expectedPermissions: AdministrationPermissions.readPermissions
        }
    },
    {
        path: "legal-consent",
        loadChildren: () =>
            import("./authorized/legal-consent/legal-consent.module").then(
                m => m.LegalConsentModule
            )
    },
    {
        path: "**",
        redirectTo: "",
        pathMatch: "full"
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
